import React, { Component } from "react";
import { Form, Dropdown, Grid } from "semantic-ui-react";
import axios from "axios";
import _ from "lodash";
import settings, { getApiHost } from "../../../settings";
import InlineError from "../../messages/InlineError";
import DppaUse from "../../dialogs/DppaUse";
import { ERR_SELECT_ITEM_IN_LIST } from "../../../ErrorMessages";

class DppaControl extends Component {
  constructor(props) {
    super(props);
    this.formDppaRef = React.createRef();
    const cancelTokenSource = axios.CancelToken.source();
    axios
      .post(
        `${getApiHost(settings.env)}/dppa.aspx`,
        {
          appName: settings.appName,
          ReportId: this.props.reportId,
          FormId: this.props.control.FormId,
        },
        { async: false }
      )
      .then((res) => {
        const options = [];
        _.map(res.data.Data, (dppa, index) => {
          options.push({
            key: dppa.DiscDesc,
            value: index + 1,
            text: dppa.DiscDesc,
            disc: dppa.DiscWording,
          });
        });
        this.setState({ options, cancelTokenSource: undefined });
      })
      .catch((err) => {
        console.log("dppa cancel error", err);
        this.setState({ cancelTokenSource: undefined });
      });
    this.state = {
      value: props.defaultData === undefined ? "" : props.defaultData,
      options: [],
      cancelTokenSource,
      active: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.firstErrorFieldName &&
      nextProps.firstErrorFieldName === nextProps.control.FieldName
    ) {
      if (!nextProps.defaultData)
        setTimeout(() => {
          this.formDppaRef.current.toggle();
        }, 100);
    }
    this.setState({
      value: nextProps.defaultData === undefined ? "" : nextProps.defaultData,
    });
  }

  componentWillUnmount() {
    if (this.state.cancelTokenSource !== undefined) {
      this.state.cancelTokenSource.cancel("Dppa unmounting...");
    }
  }

  handleStateSelect = (e, data) => {
    this.setState({ value: data.value });
    if (this.props.notifyChangeToForm !== undefined)
      this.props.notifyChangeToForm(e, { name: data.name, value: data.value });
  };

  closeDppaDialog = () => this.setState({ active: false });

  showDppaUse = () => {
    if (!this.state.active) this.setState({ active: true });
  };

  render() {
    const { control, isLeftSearch } = this.props;
    if (control === undefined) {
      return null;
    }
    const color = control.FieldRequired ? "red" : "black";
    return (
      <Grid.Row key={`drop_${control.FieldId}`}>
        {control.controlLabel !== "" &&
          (this.props.hideLabel === undefined || !this.props.hideLabel) ? (
          <Grid.Column width={isLeftSearch ? 6 : 6}>
            <DppaUse
              active={this.state.active}
              closeDppaDialog={this.closeDppaDialog}
              dppas={this.state.options}
            />
            <Form.Field>
              <span
                role={"button"}
                tabIndex={-1}
                style={{
                  color,
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
                onClick={() => this.showDppaUse()}
              >
                DPPA Use
              </span>
            </Form.Field>
          </Grid.Column>
        ) : null}
        <Grid.Column width={isLeftSearch ? 10 : 10}>
          <Form.Field>
            <Dropdown
              fluid
              search
              selectOnBlur={false}
              selection
              key={`${`dppa_${control.FormId}_${control.FieldId}`}`}
              id={`${`dppa_${control.FormId}_${control.FieldId}`}`}
              options={this.state.options}
              name={control.FieldName}
              placeholder={control.controlPlaceholder}
              value={this.state.value}
              label={control.FieldLabel}
              onChange={this.handleStateSelect}
              style={{ color: { color } }}
              ref={this.formDppaRef}
            />
          </Form.Field>
          {this.props.errors[control.FieldName] !== undefined &&
            this.props.errors[control.FieldName] !== "" && (
              <InlineError text={ERR_SELECT_ITEM_IN_LIST} />
            )}
        </Grid.Column>
      </Grid.Row>
    );
  }
}

export default DppaControl;



// WEBPACK FOOTER //
// ./src/components/forms/controls/DppaControl.js